import {DateTime} from "luxon";
import {Entity} from "./entity";
import {WeeklyWorkingTime} from "./weekly-working-time.entity";
import {formatPersonName} from "../helpers/format-person-name.helper";

export class Employee extends Entity<Employee> {

    private _weeklyWorkingTime!: Promise<WeeklyWorkingTime>;

    get weeklyWorkingTime(): Promise<WeeklyWorkingTime> {
        return this._weeklyWorkingTime;
    }

    set weeklyWorkingTime(value: Promise<WeeklyWorkingTime>) {
        this._weeklyWorkingTime = value;
        this._setOriginalValue(`weeklyWorkingTime`, value);
    }

    private _firstName: string = '';

    public get firstName(): string {
        return this._firstName;
    }

    public set firstName(value: string) {
        this._firstName = value;
        this._setOriginalValue(`firstName`, value);
    }

    private _lastName: string = '';

    public get lastName(): string {
        return this._lastName;
    }

    public set lastName(value: string) {
        this._lastName = value;
        this._setOriginalValue(`lastName`, value);
    }

    private _deletedAt: DateTime | null = null;

    public get deletedAt(): DateTime | null {
        return this._deletedAt;
    }

    public set deletedAt(value: DateTime | null) {
        this._deletedAt = value;
    }

    public get isDeleted(): boolean {
        return this._deletedAt instanceof DateTime;
    }

    /** "Nachname, Vorname"; a missing part drops its comma (see formatPersonName). */
    public get name(): string {
        return formatPersonName(this.lastName, this.firstName);
    }

    private _shortcut: string = ``;

    public get shortcut(): string {
        if (this._shortcut === ``) {
            return `${this.firstName.substring(0, 1).toLocaleUpperCase()}${this.lastName.substring(0, 1).toLocaleUpperCase()}`;
        }
        return this._shortcut;
    }

    public set shortcut(value: string) {
        this._shortcut = value;
        this._setOriginalValue(`shortcut`, value);
    }

    public toString(): string {
        return this.name;
    }
}